import ContactForm from "../../components/ContactForm";
import CreativeSlider from "../../components/sliders";
import AnimatedSlider from "../../components/sliders/animatedSlider";
import Testimonials from "../../components/Testimonials";
import ClientsSlider from "./clients";

import "./home.scss";

const chooseData = [
  {
    icon: "bx bx-code-alt",
    title: "Expert IT Solutions",
    desc: "We deliver scalable and innovative technology solutions tailored to your business goals."
  },
  {
    icon: "bx bx-shield-quarter",
    title: "Secure & Reliable",
    desc: "Our systems are built with advanced security, performance, and reliability standards."
  },
  {
    icon: "bx bx-devices",
    title: "Modern Technologies",
    desc: "We work with modern frameworks, cloud platforms, APIs, and enterprise technologies."
  },
  // {
  //   icon: "bx bx-support",
  //   title: "Dedicated Support",
  //   desc: "Our support team ensures continuous assistance, maintenance, and technical guidance."
  // },
  // {
  //   icon: "bx bx-bar-chart-alt",
  //   title: "Business Growth",
  //   desc: "We help businesses improve efficiency, automate processes, and accelerate growth."
  // },
  {
    icon: "bx bx-user-check",
    title: "Client-Focused Approach",
    desc: "We understand client requirements deeply and provide customized digital strategies."
  }
];

const Home = () => {
  return (
    <>
      {/* <CreativeSlider /> */}
      <AnimatedSlider />
      <section className="process py-5 text-center">
        <div className="container">
          <div className="section-title mb-4">
            <h6>Work Structure</h6>
            <h3 className="fw-bold">Our Development Process</h3>
          </div>
          <div className="row">
            <img src="/assets/images/development_process.svg" alt="" />
          </div>
        </div>
      </section>


      <section className="services-section">
        <div className="container">
          <div className="row clearfix">
            <div className="title-block col-xl-6 col-lg-12 col-md-12 col-sm-12">
              <div className="inner">
                <div className="sec-title">
                  <h2 className="fw-bold">Our Services</h2>
                  <div className="lower-text">We leverage advanced technologies to deliver innovative and scalable solutions that exceed expectations. At Genius World Consulting Services (GWCS), we build next-generation enterprise applications across web, mobile, and desktop platforms—helping businesses streamline operations, improve efficiency, and enhance customer experiences.</div>
                  <a href="/services" className="service-link mt-3">
                      Explore Services
                      <i className="flaticon-right-arrow"></i>
                    </a>
                </div>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft" data-wow-delay="0ms"
              data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-responsive"></span></div>
                <h6><a href="#">Tour & Travel Solutions</a></h6>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              data-wow-delay="300ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-app-development"></span></div>
                <h6><a href="">Cloud managed <br /> services</a></h6>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft" data-wow-delay="0ms"
              data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-digital-marketing"></span></div>
                <h6><a href="#">Digital <br /> Marketing</a></h6>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              data-wow-delay="300ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-development"></span></div>
                <h6><a href="#"> Software <br /> Development</a></h6>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              data-wow-delay="600ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-app-development"></span></div>
                <h6><a href="#">IT Services & <br /> Consulting </a></h6>
              </div>
            </div>
            <div className="service-block col-xl-3 col-lg-6 col-md-6 col-sm-12 wow fadeInLeft"
              data-wow-delay="900ms" data-wow-duration="1500ms">
              <div className="inner-box">
                <div className="bottom-curve"></div>
                <div className="icon-box"><span className="flaticon-ui"></span></div>
                <h6><a href="#">Technical <br /> Support</a></h6>
              </div>
            </div>
          </div>
        </div>
      </section>


      <section className="why-choose-us">
      <div className="container">

        <div className="section-header text-center">

          <span className="sub-title">
            Why Choose GWCS
          </span>

          <h2>
            Empowering Businesses Through
            <span> Smart Digital Innovation</span>
          </h2>

          <p>
            At Genius World Consulting Services (GWCS), we combine
            technology, innovation, and expertise to deliver reliable
            IT solutions that help businesses scale faster and operate smarter.
          </p>

        </div>

        <div className="row align-items-center">
          <div className="col-lg-5">

            <div className="choose-image">

              <img
                src="/assets/images/abouts.jpg"
                alt="Why Choose GWCS"
                className="img-fluid"
              />

              <div className="experience-card">
                <h3>12+</h3>
                <p>Years Experience</p>
              </div>

            </div>

          </div>

          <div className="col-lg-7">

            <div className="row g-4">

              {chooseData.map((item, index) => (
                <div
                  className="col-md-6"
                  key={index}
                >
                  <div className="choose-card h-100">

                    <div className="icon-box">
                      <i className={item.icon}></i>
                    </div>

                    <div className="content">
                      <h4>{item.title}</h4>

                      <p>{item.desc}</p>
                    </div>

                  </div>
                </div>
              ))}

            </div>

          </div>

        </div>

      </div>
    </section>

    <ClientsSlider />


      <section className="request-consultation" style={{ backgroundColor: "rgb(238, 239, 239)" }}>
        <div className="container position-relative">
          <div className="row align-items-center">
            <div className="col-md-6">
              <h3 className="title">Transform your ideas into powerful <span style={{ color: "#F9020B" }}>digital solutions</span> with GWCS</h3>
              <p>
                At Genius World Consulting Services (GWCS), we help businesses
                turn innovative ideas into scalable, secure, and high-performing
                digital solutions. From startups to enterprises, our expert team
                delivers modern web applications, mobile apps, cloud solutions,
                enterprise software, and IT consulting services tailored to your
                business goals.
              </p>

              <p>
                We believe in building long-term partnerships through innovation,
                transparency, and reliable support. Share your project requirements
                with us, and our experienced professionals will analyze your needs
                and recommend the most effective technical approach for your business.
              </p>
            </div>
            <div className="col-md-6">
              <ContactForm />
            </div>
          </div>
        </div>
      </section>

    </>
  );
};

export default Home;